import 'styled-components/macro';
import 'scroll-shadow-element';
import { useEffect, useRef } from 'react';
import { styled } from 'twin.macro';

import {
  SandboxConnectionState,
  useCheckSandboxConnection,
} from 'component-lib/organisms/terminal/useCheckSandboxConnection';
import { ChallengeTabType, LearnEnvironmentQuery } from 'types/graphql';

const Container = styled.div`
  color: white;
  padding: 16px;
`;

interface Props {
  challenge: NonNullable<LearnEnvironmentQuery['challenge']>;
}

export const ChecksCreation = ({ challenge }: Props) => {
  const wsConnected = useRef(false);

  // current scope: only one virtual browser tab per challenge
  const virtualBrowserTab = challenge.tabs.find(tab => tab.type === ChallengeTabType.Browser);
  const targeturl = virtualBrowserTab?.target;

  const { connectionState, connectedUrl } = useCheckSandboxConnection({ url: targeturl || '' });

  useEffect(() => {
    if (connectionState !== SandboxConnectionState.connected || !connectedUrl || wsConnected.current) {
      return;
    }
    const wsURL = new URL(connectedUrl.replace(/^http/, 'ws').replace(/9000/, '15780'));
    wsURL.pathname = 'ws';
    const ws = new WebSocket(wsURL);

    ws.onopen = () => {
      wsConnected.current = true;
      ws.send('frontend connected');
    };

    ws.onclose = () => {
      wsConnected.current = false;
    };

    return () => {
      ws.close();
    };
  }, [connectionState, connectedUrl]);

  return (
    <Container>
      <h1>Here you can create your checks for virtual browser</h1>
      <p>Please follow the instructions.</p>
      {connectionState !== SandboxConnectionState.connected && 'Waiting for connection...'}
    </Container>
  );
};
